import {
  logoAT,
  logoCE,
  logoDT,
  logoEducEmp,
  logoGOV,
  logoSelo,
  logoTerritorio,
} from "./logosSistemas";
import titulos from "./titleSistema";

const branch = "hlg";

/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  isIndicadores: false,
  isSala: false,
  isParceiro: false,
  isAT: false,
  isEducEmp: false,
  isCE: false,
  isEducEmp: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  {
    tag: "dev.sistemaselosebrae.com.br",
    uf: "SP",
    banco: "selo-dev",
    isCE: true,
  },
  {
    tag: "hlg.sistemaselosebrae.com.br",
    uf: "SP",
    banco: "selo-hlg",
    isSala: true,
  },
  {
    tag: "dev.sistemaselosebrae.com.br",
    uf: "SP",
    banco: "selo-dev",
    isCE: true,
  },
  {
    tag: "hlg.selosaladoempreendedor.com.br",
    uf: "SP",
    banco: "selo-hlg",
    isSala: true,
  },
  {
    tag: "hlg.cidadeempreendedora.com.br",
    uf: "SP",
    banco: "ce-hlg",
    isCE: true,
  },
  {
    tag: "dev.sistemaselosebrae.com.br",
    uf: "SP",
    banco: "ce-dev",
    isCE: true,
  },

  //#region selo 2025
  ...[
    "rj",
    "al",
    "ac",
    "ms",
    "ma",
    "sp",
    "es",
    "ba",
    "sc",
    "ap",
    "am",
    "ce",
    "go",
    "mt",
    "pa",
    "pb",
    "pr",
    "pe",
    "pi",
    "rn",
    "mg",
    "rs",
    "ro",
    "rr",
    "se",
    "to",
    "df",
  ].flatMap((item) => [
    //#region HLG
    {
      tag: `${item}-hlg.cidadeempreendedora.com.br`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg-parceiros.sistemaselosebrae.com.br`,
      banco: `selo-${item}-hlg-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
    },
    {
      tag: `${item}-hlg.sistemaselosebrae.com.br`,
      banco: `selo-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg.empreendedoraeducacao.com.br`,
      banco: `edu-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg.selosaladoempreendedor.com.br`,
      banco: `selo-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg-parceiros.selosaladoempreendedor.com.br`,
      banco: `selo-${item}-hlg-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
    },
    {
      tag: `${item}-hlg.agentesterritoriais`,
      banco: `agentes-territoriais--${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg.territoriosempreendedores`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-hlg.desenvolvimentoterritorial`,
      banco: `ce-${item}-hlg`,
      uf: item.toUpperCase(),
    },
    //#endregion HLG
    //#region  PROD
    {
      tag: `${item}.cidadeempreendedora.com.br`,
      banco: `${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-parceiros.sistemaselosebrae.com.br`,
      banco: `selo-sala-${item}-parceiros`,
      uf: item.toUpperCase(),
      isParceiro: true,
      isSala: true,
    },
    {
      tag: `${item}.sistemaselosebrae.com.br`,
      banco: `selo-sala-${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}.sistemaselosebrae.com.br`,
      banco: `selo-sala-${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}.selosaladoempreendedor.com.br`,
      banco: `selo-sala-${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}-parceiros.selosaladoempreendedor.com.br`,
      banco: `selo-sala-${item}-parceiros`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}.agentesterritoriais`,
      banco: `agentes-territoriais-${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}.territoriosempreendedores`,
      banco: `${item}`,
      uf: item.toUpperCase(),
    },
    {
      tag: `${item}.desenvolvimentoterritorial`,
      banco: `${item}`,
      uf: item.toUpperCase(),
    },
    //#endregion PROD
  ]),

  {
    tag: "indicadores-sp",
    banco: "cidade-empreendedora-sp-indicadores",
    uf: "SP",
    isIndicadores: true,
  },
  { tag: "indicadores.consorcioempreendedor", banco: "sp", uf: "SP" },

  {
    tag: "localhost",
    banco: process.env.VUE_APP_LOCAL_BANCO || "ce-ma-hlg",
    uf: process.env.VUE_APP_LOCAL_UF || "MA",
    isSala: process.env.VUE_APP_LOCAL_SYSTEM === "selo",
    isCE: process.env.VUE_APP_LOCAL_SYSTEM !== "selo",
    isParceiro: false,
    ambient: process.env.VUE_APP_LOCAL_AMBIENTE || "dev",
    env: process.env.VUE_APP_BASE_API_LOCAL,
  },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

export const EnumAmbienteTipos = {
  prod: "prod",
  dev: "dev",
  hlg: "hlg",
};

let atual;
const hrf = window.location.href;
const ceDevBanco = "ce-dev";
const ceHlgBanco = "ce-hlg";

ufsDefinitions.forEach((item) => {
  if (hrf.includes("sistemaselo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("selo")) {
    if (hrf.includes("parceiros")) {
      item.isParceiro = true;
    }
    item.isSala = true;
  } else if (hrf.includes("agentesterritoriais")) {
    item.isAT = true;
  } else if (hrf.includes("governancaempreendedora")) {
    item.isGov = true;
  } else if (hrf.includes("desenvolvimentoterritorial")) {
    item.isDT = true;
  } else if (hrf.includes("territoriosempreendedores")) {
    item.isTerritorio = true;
  } else if (
    hrf.includes("educempreendedora") ||
    hrf.includes("empreendedoraeducao")
  ) {
    item.isEducEmp = true;
  } else if (hrf.includes("cidadeempreendedora")) {
    item.isCE = true;
  }

  if (item.isSala || item.isParceiro) {
    if (!item.title) item.title = titulos.sala;
    if (!item.corPrimaria) item.corPrimaria = "#2a4fd7";
    if (!item.logos) item.logos = logoSelo;
  } else if (item.isAT) {
    if (!item.title) item.title = titulos.at;
    if (!item.logos) item.logos = logoAT;

    if (!item.corPrimaria) item.corPrimaria = "#93CE98";
    if (!item.logo) item.logo = "logo_at_branca.png";
  } else if (item.isGov) {
    if (!item.title) item.title = titulos.gov;
    if (!item.logos) item.logos = logoGOV;
    if (!item.logo) item.logo = "Logo_Governança_Empreendedora-branca.png";
    if (!item.corPrimaria) item.corPrimaria = "#9079A8";
  } else if (item.isDT) {
    if (!item.title) item.title = titulos.dt;
    if (!item.logos) {
      item.logos = logoDT;
    }
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else if (item.isTerritorio) {
    if (!item.title) item.title = titulos.territorio;
    if (!item.logos) {
      item.logos = logoTerritorio;
    }
    if (!item.corPrimaria) item.corPrimaria = "#000";
  } else if (item.isEducEmp) {
    if (!item.title) item.title = titulos.isEducEmp;
    if (!item.logos) {
      item.logos = logoEducEmp;
    }
    if (!item.corPrimaria) item.corPrimaria = "#908dc4";
  } else {
    if (!item.logo) item.logo = "logo_nacional.png";
    if (!item.logos) item.logos = logoCE;
    if (!item.title) item.title = titulos.ce;
    if (!item.corPrimaria) item.corPrimaria = "#000";
  }

  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (
      item.tag.indexOf("dev") !== -1 ||
      item.tag.indexOf("amazonaws.com") !== -1
    ) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO -----------------!"
      );

      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_DEV;
      item.ambient = EnumAmbienteTipos.dev;

      if (!item.banco) {
        item.banco = ceDevBanco;
      }
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE HOMOLOGAÇÃO -----------------!"
      );
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_HLG;
      item.ambient = EnumAmbienteTipos.hlg;

      if (!item.banco) {
        item.banco = ceHlgBanco;
      }
      // urls com localhost no nome
    } else if (item.tag.indexOf("localhost") !== -1) {
      console.log(
        "!----------------- AMBIENTE DE DESENVOLVIMENTO LOCAL -----------------!"
      );
      if (!item.banco) {
        item.banco = ceDevBanco;
      }

      item.ambient = item.ambient || EnumAmbienteTipos.dev;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      console.log("!----------------- AMBIENTE DE PRODUÇÃO -----------------!");
      item.ambient = EnumAmbienteTipos.prod;
      if (!item.env) item.env = process.env.VUE_APP_BASE_API_CE_PROD;
    }

    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

window.atualUfDefinition = atualUfDefinition;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      const indexOfArroba = str.indexOf("@", 0);
      const indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      const names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (typeof a === "string" && typeof b === "string") {
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return -1;
    }
    if (
      a.normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
      b.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    ) {
      return 1;
    }
  } else {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
  }
  return 0;
};

export const isSPHlg = ["sp-hlg.cidadeempreendedora.com.br"].some((host) =>
  window.location.host.startsWith(host)
);

export const isSP = [
  "sp.cidadeempreendedora.com.br",
  "sp.territoriosempreendedores.com.br",
  "sp.desenvolvimentoterritorial.com.br",
].some((host) => window.location.host.startsWith(host));

export const isSPNewUser = () => {
  return isSP && window.spUser && window.spUser.grupoId === 10;
};
